import { Route, Routes } from "react-router-dom";
import CandidateHome from "./CandidateHome";
import CandidatePage from "./CandidatePage";

function Candidate() {
    return (
        <Routes>
            <Route path={"/"} element={<CandidateHome />} />
            <Route path={"/:id"} element={<CandidatePage />} />
        </Routes>
    );
}

export default Candidate;
